import React, { useState } from 'react';
import { Grid, TextField } from '@mui/material';
import _ from 'lodash';
import deepmerge from 'deepmerge';

import SelectField from '../../common/select_field';
import { getCustomerFilterOptions, getCustomerStatusOptions } from '../../common/utils/customer_utils';
import FilterPaper from '../../common/filter_paper';

const CustomerFilters = ({ queryParams, setQueryParams }) => {
    const [queryFilter, setQueryFilter] = useState(queryParams?.queryFilter || 'none');
    const [customerStatus, setCustomerStatus] = useState(queryParams?.status || 'ALL');

    const onSearchInputChangeDebounced = _.debounce((value) => onSearchInputChange(value), 600);

    const onSearchInputChange = (query) => {
        setQueryParams(prevState => deepmerge(prevState, { queryValue: query }));
    };

    const onSelectQueryFilterChange = (event) => {
        setQueryFilter(event.target.value);

        if (event.target.value === 'none') {
            setQueryParams(prevState => deepmerge(prevState, { queryFilter: '', queryValue: '' }));
        } else {
            setQueryParams(prevState => deepmerge(prevState, { queryFilter: event.target.value }));
        }
    };

    const onSelectCustomerStatusChange = (event) => {
        setCustomerStatus(event.target.value);
        setQueryParams(prevState => deepmerge(prevState, { status: event.target.value }));
    };

    return (
        <FilterPaper title="Filtry użytkowników">
            <Grid container spacing={ 3 } alignItems="flex-start">

                <Grid item xs={ 12 } sm={ 6 } md={ 3 }>
                    <SelectField
                        size="small"
                        label="Status"
                        value={ customerStatus }
                        onChange={ onSelectCustomerStatusChange }
                        options={ [{ value: 'ALL', label: 'Wszystkie' }, ...getCustomerStatusOptions] }
                    />
                </Grid>

                <Grid item xs={ 12 } sm={ 6 } md={ 3 }>
                    <SelectField
                        size="small"
                        label="Wyszukiwanie po ..."
                        value={ queryFilter }
                        onChange={ onSelectQueryFilterChange }
                        options={ [{ value: 'none', label: 'Nie wybrano' }, ...getCustomerFilterOptions] }
                    />
                </Grid>

                { queryFilter !== 'none' && (
                    <Grid item xs={ 12 } sm={ 12 } md={ 4 }>
                        <TextField
                            size="small"
                            label="Szukaj"
                            helperText="Pole nie może być puste"
                            fullWidth
                            placeholder={ queryParams?.queryValue }
                            onChange={ event => onSearchInputChangeDebounced(event.target.value) }
                            InputLabelProps={ queryParams?.queryValue ? { shrink: true } : undefined }
                        />
                    </Grid>
                ) }

            </Grid>
        </FilterPaper>
    );
};

export default CustomerFilters;